import { List, Record } from 'immutable';
import DefaultSort from 'SalesContentIndexUI/data/lib/DefaultSort';
import * as DefaultFilterNames from 'SalesContentIndexUI/data/lib/DefaultFilterNames';
export default Record({
  id: null,
  getTitle: () => '',
  type: DefaultFilterNames.DEFAULT,
  getFilters: () => List(),
  getSearchQueryOverride: null,
  getSort: () => DefaultSort,
  getDisabledTooltipCopy: null,
  isDisabled: () => false
}, 'SearchViewFilterRecord');